<template>
  <div class="public-auth">
    <!-- 未授权组件 -->
    <div v-if="isAuth===false">
      <unauth @validateDialog="getValidateDialog"></unauth>
    </div>
    <!-- 已授权组件 -->
    <div v-else-if="isAuth===true">
      <auth
        :app-id="toChildAppId"
        :authorizer-info="authorizerInfo"
        @validateDialog="getValidateDialog"
      ></auth>
    </div>
    <div class="auth-callback-dialog">
      <!-- 验证授权弹窗 -->
      <mk-dialog
        title="请您注意"
        :visible.sync="validateDialog"
        width="30%"
      >
        请在新打开的窗口完成授权
        <span
          slot="footer"
          class="dialog-footer"
        >
          <mk-button-biz @click="reloadPage">授权失败</mk-button-biz>
          <mk-button-biz
            type="primary"
            @click="reloadPage"
          >授权成功</mk-button-biz>
        </span>
      </mk-dialog>
      <!-- 重新授权弹窗 -->
      <mk-dialog
        title="请您注意"
        :visible.sync="reAuthDialog"
        width="30%"
      >
        {{ msg }}
        <span
          slot="footer"
          class="dialog-footer"
        >
          <mk-button-biz
            type="primary"
            @click="reAuth"
          >重新授权</mk-button-biz>
          <mk-button-biz @click="cancelReAuth">取消</mk-button-biz>
        </span>
      </mk-dialog>
      <!-- 授权成功弹窗 -->
      <mk-dialog
        title="授权成功"
        width="30%"
        :visible.sync="confirmAuthSuccess"
      >
        您已成功授权
        <span
          slot="footer"
          class="dialog-footer"
        >
          <mk-button-biz
            type="primary"
            @click="confirmAuthSuccess=false"
          >确认</mk-button-biz>
        </span>
      </mk-dialog>
    </div>
  </div>
</template>

<script>
import unauth from './components/unauth'
import auth from './components/auth'
const { VUE_APP_PC_B_BASE_URL, VUE_APP_WX_OPEN_BASE_URL } = process.env
export default {
  name: 'PublicAuth',
  components: { unauth, auth },
  mixins: [],
  props: {},
  data () {
    return {
      isAuth: '',
      authorizerAppId: '',
      // 传给子级用于解绑的id
      toChildAppId: '',
      code: this.$route.query.code,
      msg: '',
      // 验证授权弹窗
      validateDialog: false,
      // 重新授权弹窗状态
      reAuthDialog: false,
      // 授权成功提示弹窗
      confirmAuthSuccess: false,
      // 传给已授权组件的展示内容，包括用户信息appID等
      authorizerInfo: {}
    }
  },
  mounted () {
    this.getUserInfo()
    this.getRouterQuery()
  },
  destroyed () {},
  methods: {
    // 授权事件
    toAuth () {
      const dustessUrl = encodeURIComponent(
        window.location.origin + '/#/settings/auth-management'
      )
      const { account } = JSON.parse(window.localStorage.getItem('user'))
      const url = `${VUE_APP_WX_OPEN_BASE_URL}/wxopen/v1/auth/page?companyId=${account}&dustessUrl=${dustessUrl}`
      window.open(url)
      this.$emit('validateDialog', true)
    },
    // 初始化获取用户信息以及判断用户是否授权
    async getUserInfo () {
      let res = await BIZAPIS.ManageApi.authManageWeixinAccountGet()
      if (res.success === true) {
        // 已授权
        this.isAuth = true
        this.toChildAppId = res.data.authorizationAppId
        this.authorizerInfo = res.data.authorizerInfo
      } else if (res.success === false) {
        // 未授权
        this.isAuth = false
      }
    },
    // 初始化获取路由信息根据code判断授权是否成功
    getRouterQuery () {
      let query = this.$route.query
      if (query.code === '0') {
        this.reAuthDialog = false
        this.confirmAuthSuccess = true
        this.authorizerAppId = query.authorizerAppId
      } else if (query.code && query.code !== '0') {
        this.msg = query.msg
        this.reAuthDialog = true
        this.isAuth = false
      }
    },
    // 用户操作‘授权失败’或‘授权成功’弹窗状态
    getValidateDialog (val) {
      this.validateDialog = val
    },
    // 用户点击验证弹窗‘授权失败/授权成功’重新加载页面’
    reloadPage () {
      location.reload()
    },
    // 回调页，授权失败，重新授权
    reAuth () {
      this.reAuthDialog = false
      this.validateDialog = true
      this.toAuth()
    },
    // 回调页，授权失败，取消授权
    cancelReAuth () {
      this.reAuthDialog = false
    }
  }
}
</script>
